module.exports = __webpack_public_path__ + "static/media/videoFileIcon.b01fb348.svg";